module.exports = __webpack_public_path__ + "img/3.06113958.jpg";